import LinearProgress, {
  linearProgressClasses,
  LinearProgressProps,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import * as React from 'react';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: theme.spacing(1.25),
  borderRadius: theme.spacing(0.625),
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: theme.spacing(0.625),
    backgroundColor: theme.palette.common.black,
  },
}));

export const BorderProgressBar: React.FC<LinearProgressProps> =
  React.forwardRef((props: LinearProgressProps, ref) => {
    return <BorderLinearProgress {...props} ref={ref} />;
  });
